import moment from 'moment';

export function debounce (func, wait, immediate) {
    let timeout;
    return function () {
        let context = this;
        let args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// en algunos casos capaz que se necesite throttle
export function executeOnceInTime (func, wait) {
    let timeout;
    let waitTimePass = true;
    return function () {
        let context = this;
        let args = arguments;
        let later = function () {
            waitTimePass = true;
        };
        if (waitTimePass) {
            func.apply(context, args);
            waitTimePass = false;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        }
    };
}

export function today () {
    let _today = new Date();
    let dd = _today.getDate();
    let mm = _today.getMonth() + 1;
    let yyyy = _today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    return yyyy + '-' + mm + '-' + dd;
}

export function getRoute (value, subRoute = '') {
    if (!subRoute) {
        subRoute = '';
    }

    if (value && value.length) {
        return process.env.API_URL + subRoute + value;
    }
}

export function inputIsNumber (event) {
    if (event.type.toUpperCase() === 'KEYDOWN') {
        if (!eventNumberKeyInput(event)) {
            event.preventDefault();
            return event;
        }
    } else if (event.type.toUpperCase() === 'PASTE') {
        if (!eventNumberPaste(event)) {
            event.preventDefault();
            return false;
        };
    }
}

export function isDigit (code) {
    let stringCode = String.fromCharCode(code);
    return /^\d$/.test(stringCode);
}

export function isNumber (variable) {
    return /^\d+$/.test(variable);
}

export function eventNumberKeyInput (event) {
    if (event.ctrlKey || event.altKey ||
            (event.keyCode > 47 && event.keyCode < 58 && event.shiftKey === false) ||
            (event.keyCode > 95 && event.keyCode < 106) ||
            (event.keyCode === 8) || (event.keyCode === 9) ||
            (event.keyCode > 34 && event.keyCode < 40) ||
            (event.keyCode === 46)) {
        return true;
    } else {
        return false;
    }
}

export function eventNumberPaste (event) {
    if (clipboardIsNumeric(event)) {
        return true;
    } else {
        return false;
    }
}

export function clipboardIsNumeric (event) {
    var clipboardData = (event.clipboardData) ? event.clipboardData.getData('Text') : window.clipboardData.getData('Text');
    var isNumber = /^\d+$/.test(clipboardData);
    return (isNumber);
}

export function getCssVarValue (variable) {
    return window.getComputedStyle(document.body).getPropertyValue(variable);
}

export function getDistanceFromLatLonInKm (lat1, lon1, lat2, lon2) {
    function deg2rad (deg) {
        return deg * (Math.PI / 180);
    }
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

export function mergeArrays (arr1, arr2) {
    let arr3 = [];
    for (let i in arr1) {
        let shared = false;
        for (let j in arr2) {
            if (arr2[j].id === arr1[i].id) {
                shared = true;
                break;
            }
        }
        if (!shared) {
            arr3.push(arr1[i]);
        }
    }
    return arr3.concat(arr2);
}

export function _blankSpaceIfNotExist (data, suffix) {
    if (!data) {
        data = '';
    } else {
        data = suffix + data;
    }
    return data;
}

// Parse google results
export function _parseGoogleResult (result) {
    let address = {};
    for (let i in result.address_components) {
        let obj = result.address_components[i];
        let nombre = obj.long_name;
        switch (obj.types[0]) {
            case 'country':
                address.pais = nombre;
                break;
            case 'administrative_area_level_1':
                address.provincia = nombre;
                break;
            case 'locality':
                address.ciudad = nombre;
                break;
            case 'route':
                address.calle = nombre;
                break;
            case 'street_number':
                var altura = parseInt(nombre, 10);
                if (!isNaN(altura)) {
                    address.numero = altura;
                } else {
                    address.numero = -1;
                }
                break;
            case 'neighborhood':
                address.barrio = nombre;
                break;
            case 'political':
                if (obj.type && obj.type.length > 1 && obj.type[1] === 'sublocality' && !address.barrio) {
                    address.barrio = nombre;
                }
                break;
            case 'intersection':
                address.description = nombre;
                break;
        };
        if (!address.numero) {
            address.numero = -1;
        }
    }
    return address;
}

export function _parseOSMResult (result) {
    let address = {};
    address.calle = result.road;
    let altura = parseInt(result.house_number, 10);
    if (!isNaN(altura)) {
        address.numero = altura;
    } else {
        address.numero = 0;
    }
    address.barrio = result.suburb;
    address.pais = result.country;
    address.provincia = result.state;
    address.ciudad = result.city;

    return address;
}

export function _normalizeText (str) {
    let rExps = [
        {re: /[\xC0-\xC6]/g, ch: 'A'},
        {re: /[\xE0-\xE6]/g, ch: 'A'},
        {re: /[\xC8-\xCB]/g, ch: 'E'},
        {re: /[\xE8-\xEB]/g, ch: 'E'},
        {re: /[\xCC-\xCF]/g, ch: 'I'},
        {re: /[\xEC-\xEF]/g, ch: 'I'},
        {re: /[\xD2-\xD6]/g, ch: 'O'},
        {re: /[\xF2-\xF6]/g, ch: 'O'},
        {re: /[\xD9-\xDC]/g, ch: 'U'},
        {re: /[\xF9-\xFC]/g, ch: 'U'},
        {re: /[\xD1]/g, ch: 'N'},
        {re: /[\xF1]/g, ch: 'N'}
    ];

    for (let i = 0, len = rExps.length; i < len; i++) {
        str = str.replace(rExps[i].re, rExps[i].ch);
    }

    return str.toUpperCase();
}

window.mergeArrays = mergeArrays;
window.normalizeText = _normalizeText;

export function getPreformattedCancelationOptions (razonesCancelacion, isDriver, language) {
    let options = [];
    isDriver = isDriver !== null;
    if (razonesCancelacion) {
        console.log('razonesCancelacion', razonesCancelacion);
        console.log('isDriver', isDriver);
        let _opts = {};
        if (isDriver && razonesCancelacion.driver) {
            _opts = razonesCancelacion.driver;
        }
        if (!isDriver && razonesCancelacion['passenger']) {
            _opts = razonesCancelacion['passenger'];
        }
        console.log('_opts', _opts);
        for (const keylang in _opts) {
            if (_opts.hasOwnProperty(keylang)) {
                const lang = _opts[keylang];
                if (keylang === language) {
                    for (const key in lang) {
                        if (lang.hasOwnProperty(key)) {
                            const element = lang[key];
                            options.push({ key: key, value: element });
                        }
                    }
                }
            }
        }
    }
    return options;
}

export function showCancelModal (trip) {
    // this is a vue.js VM
    const cancelReasonKey = this.isDriver ? 'viajeCaneladoPorPasajero' : 'viajeCaneladoPorChofer';
    let reason = this.translate(cancelReasonKey);
    reason += this.cancelReasonModuleEnabled ? (this.translate('reason') + trip.comentario_rechazo) : '';
    let date = moment(trip.created_at).format('HH:mm');
    let mensaje = date + ' - ' + trip.calle + ' ' + (trip.altura >= 0 ? trip.altura : '') + ': ';
    mensaje += reason;
    let options = {
        isForgettable: false,
        isModal: false,
        callback: () => {}
    };
    if (trip.razon_cancelacion) {
        console.log('razon_cancelacion', this.settings.razones_cancelacion, this.isDriver, this.language);
        let options = getPreformattedCancelationOptions(this.settings.razones_cancelacion, this.isDriver ? null : this.isDriver, this.language);
        console.log('options', options);
        if (options && options.length) {
            let opt = options.find(o => o.key === trip.razon_cancelacion);
            mensaje += ' Motivo: ' + (opt ? opt.value : ''); // [trip.razon_cancelacion];
        }
    }
    if (this.markAsAlerted) {
        this.markAsAlerted(trip);
    }
    this.$alertForgettable('canceled_trip_' + trip.id, mensaje, options);
    this.caceledViewed(trip.id);
}



// WEBPACK FOOTER //
// ./src/services/utility.js